// extracted by mini-css-extract-plugin
export var linkText = "_og-0";